/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

//ran thru claudes code refactoring tool

// redesign this component to look more elegant and polished
// Use Tailwind CSS className only. Preserve all logic, Redux hooks, and routing exactly as-is.
// use tailwind css in the className directive 
// ask me a series of questions to gather additional context you need to best achive this task
// "Colors come from dynamic seller props — use hex + opacity string concatenation (e.g. sellerPrimaryColor1 + '20') for tints, never hardcode colors."
// Give me the complete code with instructions





import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { Range } from 'react-range';

import { IoIosArrowForward } from 'react-icons/io';
import { AiFillStar } from 'react-icons/ai';
import { CiStar } from 'react-icons/ci';
import { BsFillGridFill } from 'react-icons/bs';
import { FaThList } from 'react-icons/fa';

import { price_range_product, query_products } from '../store/reducers/homeReducer';

import Header from '../components/Header';
import Footer from '../components/Footer';
import Pagination from '../components/Pagination';
import ShopBanner from '../components/ShopBanner';
import Products from '../components/products/Products';
import ShopProductGridListView from '../components/products/ShopProductGridListView';
import GetSellerConfig from '../components/GetSellerConfig';

import config from '../config';

// Reusable star rating row — eliminates 30+ repeated <span> elements
const StarRatingRow = ({ filled, onClick }) => (
  <div
    onClick={onClick}
    className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
  >
    {Array.from({ length: 5 }, (_, i) =>
      i < filled ? <AiFillStar key={i} /> : <CiStar key={i} />
    )}
  </div>
);

const CategoryShop = () => {
  const sellerFrontendURL = config.STR_FRONTEND_URL;
  const intPriceRangeStep = config.INT_FRONTEND_PRICE_RANGE_STEP;

  const { products, priceRange, latest_product, totalProduct, parPage } =
    useSelector((state) => state.home);
  const { seller } = useSelector((state) => state.seller);
  const { sellerComponentBackgroundColor } = GetSellerConfig();

  const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1;
  const sellerSecondaryColor1 = seller?.frontEndSecondaryColor1;
  
  const sellerArrHexOpacityColorSuffixes = seller?.hexOpacityColorSuffixes?.split(';') || [];
  const sellerColorSuffixDark   = sellerArrHexOpacityColorSuffixes[0] || 'FF';
  const sellerColorSuffixMedium = sellerArrHexOpacityColorSuffixes[1] || '80';
  const sellerColorSuffixLight  = sellerArrHexOpacityColorSuffixes[2] || '1A';
    
  const sellerProductTerm = seller?.productTerm;
  const sellerProductPluralTerm = seller?.productPluralTerm;

  const sellerBoolShowSitePayments = seller?.isVisibleSitePayments === 'Show';
  const sellerBoolShowSiteRating = seller?.isVisibleSiteRating === 'Show';
  const sellerBoolShowSiteProductsUnderFilter = seller?.isVisibleSiteProductsUnderFilter === 'Show';

  // Sidebar is shown only when none of the optional sections are visible
  const sellerBoolShowSidebar =
    !sellerBoolShowSitePayments &&
    !sellerBoolShowSiteRating &&
    !sellerBoolShowSiteProductsUnderFilter;

  const [searchParams] = useSearchParams();
  const category = searchParams.get('category');

  const dispatch = useDispatch();

  const [filter, setFilter] = useState(true);
  const [state, setState] = useState(null);
  const [rating, setRating] = useState('');
  const [styles, setStyles] = useState('grid');
  const [pageNumber, setPageNumber] = useState(1);
  const [sortPrice, setSortPrice] = useState('');

  // Sync price range slider when priceRange loads from the store
  useEffect(() => {
    dispatch(price_range_product(sellerFrontendURL));
  }, []);

  useEffect(() => {
    if (priceRange.low !== undefined && priceRange.high !== undefined) {
      setState({ values: [priceRange.low, priceRange.high] });
    }
  }, [priceRange]);

  // Re-query whenever any filter or pagination value changes
  useEffect(() => {
    if (!state) return; // wait until priceRange is synced
    dispatch(
      query_products({
        webSiteOrigin: sellerFrontendURL,
        low: state.values[0] || '',
        high: state.values[1] || '',
        category,
        mainIngredient: '',
        FMP: '',
        cookingMethod: '',
        byThePan: '',
        dietaryRestrictions: '',
        cuisineType: '',
        holiday: '',
        rating,
        sortPrice,
        pageNumber,
      })
    );
  }, [sellerFrontendURL, state, category, rating, sortPrice, pageNumber,]);

  const resetFilter = useCallback(() => {
    setRating('');
    setSortPrice('');
    setPageNumber(1);
    dispatch(price_range_product(sellerFrontendURL));
  }, [dispatch, sellerFrontendURL]);

  const showResetButton = sellerBoolShowSitePayments || sellerBoolShowSiteRating;

  return (
    <div >
      <Header />
      <section className="">
        {/*  w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto border border-black
          w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto */}
        <div className="">
          <div className="">
            <ShopBanner
              homePage="Home" homeLink="/"
              currentPageTop="Category Page" currentPageTopLink=""
              currentPageBottom1={category} currentPageBottomLink1={`/productsCategory?category=${category}`}
              currentPageBottom2="" currentPageBottomLink2=""
            />
          </div>
          <div style={{ backgroundColor: sellerComponentBackgroundColor }}>
            <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto pt-4 border-none border-black">
              {/* Mobile filter toggle */}
              <div className={`md:block hidden ${!filter ? 'mb-6' : 'mb-0'}`}>
                <button
                  onClick={() => setFilter((prev) => !prev)}
                  className="text-center rounded-lg w-full py-2 px-3 text-white"
                  style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                  Filter {sellerProductPluralTerm}
                </button>
              </div>
              <div className="w-full flex flex-wrap">
                {/* Sidebar */}
                <div
                  className={`w-3/12 md-lg:w-4/12 md:w-full pr-8 ${
                    filter
                      ? 'md:h-0 md:overflow-hidden md:mb-6'
                      : 'md:h-auto md:overflow-auto md:mb-0'
                  }`}>
                  {/* Price Range */}
                  {sellerBoolShowSitePayments && state &&  (
                    <div className="py-2 flex flex-col gap-2 border-none border-black">
                      <div
                        className="text-2xl font-bold mb-3"
                        style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                        Price
                      </div>
                      <Range
                        step={intPriceRangeStep}
                        min={priceRange.low}
                        max={priceRange.high}
                        values={state.values}
                        onChange={(values) => setState({ values })}
                        renderTrack={({ props, children }) => (
                          <div
                            {...props}
                            className="ml-3 w-[92%] h-[6px] bg-slate-200 rounded-full cursor-pointer">
                            {children}
                          </div>
                        )}
                        renderThumb={({ props }) => (
                          <div
                            className="w-[15px] h-[15px] bg-[#059473] rounded-full"
                            {...props}
                          />
                        )}
                      />
                      <div>
                        <span
                          className="ml-1 font-bold text-lg"
                          style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                          ${Math.floor(state.values[0])} – ${Math.floor(state.values[1])}
                        </span>
                      </div>
                    </div>
                  )}

                  {/* Star Rating Filter */}
                  {sellerBoolShowSiteRating && (
                    <div className="py-3 flex flex-col gap-2">
                      <div
                        className="text-2xl font-bold mb-1"
                        style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                        Rating
                      </div>
                      <div className="ml-1 flex flex-col gap-3">
                        {[5, 4, 3, 2, 1].map((stars) => (
                          <StarRatingRow
                            key={stars}
                            filled={stars}
                            onClick={() => setRating(stars)}
                          />
                        ))}
                        {/* "Any rating" / clear rating row */}
                        <StarRatingRow filled={0} onClick={() => setRating('')} />
                      </div>
                    </div>
                  )}

                  {/* Reset Filter */}
                  {showResetButton && (
                    <button
                      onClick={resetFilter}
                      style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}
                      className="text-center rounded-lg w-full py-2 px-3 text-white">
                      Reset Filter
                    </button>
                  )}

                  {/* Latest products under sidebar */}
                  {sellerBoolShowSiteProductsUnderFilter && (
                    <div className="py-5 flex flex-col gap-4 md:hidden">
                      <Products
                        title={`Latest ${sellerProductPluralTerm}`}
                        products={latest_product}
                        parentPage="CategoryShop"
                      />
                    </div>
                  )}
                </div>

                {/* Product Grid */}
                <div
                  className={`${
                    sellerBoolShowSidebar ? '' : 'w-9/12 md-lg:w-8/12'
                  } md:w-full`}>
                  <div className={`${sellerBoolShowSidebar ? '' : 'pl-8'} md:pl-0`}>
                    {/* Toolbar 
                    className="py-2 bg-white mb-10 px-3 rounded-md flex justify-between items-start border"
                    */}
                    <div className="bg-white">
                      <div className="px-3 py-1 mb-2 gap-0.5 rounded-lg flex justify-between items-center border"
                          style={{
                              color: sellerPrimaryColor1 + sellerColorSuffixDark,
                              borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
                              backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
                          }}>
                        <div
                          className="text-[18px] font-medium"
                          style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                          {totalProduct} {sellerProductTerm}
                          {totalProduct !== 1 && 's'} ({category})
                        </div>
                        <div className="flex justify-center items-center gap-2 ml-auto">
                          {sellerBoolShowSitePayments && (
                              <select
                                  onChange={(e) => setSortPrice(e.target.value)}
                                  className="py-1.5 px-2.5 rounded-lg border text-sm font-medium outline-none bg-white cursor-pointer"
                                  style={{
                                      color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                      borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
                                  }}>
                                  <option value="">Sort By</option>
                                  <option value="low-to-high">Price: Low → High</option>
                                  <option value="high-to-low">Price: High → Low</option>
                              </select>
                          )}

                          {/* Grid / List toggle */}
                          <div
                              className="flex rounded-lg border overflow-hidden md-lg:hidden"
                              style={{ borderColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                              <button
                                  onClick={() => setStyles('grid')}
                                  className="p-1.5 transition-colors"
                                  style={{
                                      backgroundColor: styles === 'grid' ? sellerPrimaryColor1 + sellerColorSuffixLight : 'white',
                                      color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                  }}>
                                  <BsFillGridFill size={16} />
                              </button>
                              <button
                                  onClick={() => setStyles('list')}
                                  className="p-1.5 transition-colors"
                                  style={{
                                      backgroundColor: styles === 'list' ? sellerPrimaryColor1 + sellerColorSuffixLight : 'white',
                                      color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                      borderLeft: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
                                  }}>
                                  <FaThList size={16} />
                              </button>
                          </div>
                          {
                          // <div className="hidden flex justify-center items-start gap-4 md-lg:hidden">
                          //   <div
                          //     onClick={() => setStyles('grid')}
                          //     className={`p-2 ${
                          //       styles === 'grid' ? 'bg-slate-300' : ''
                          //     } text-slate-600 hover:bg-slate-300 cursor-pointer rounded-sm`}
                          //   >
                          //     <BsFillGridFill style={{ color: sellerPrimaryColor1 }} />
                          //   </div>
                          //   <div
                          //     onClick={() => setStyles('list')}
                          //     className={`p-2 ${
                          //       styles === 'list' ? 'bg-slate-300' : ''
                          //     } text-slate-600 hover:bg-slate-300 cursor-pointer rounded-sm`}
                          //   >
                          //     <FaThList style={{ color: sellerPrimaryColor1 }} />
                          //   </div>
                          // </div>
                          }
                        </div>
                      </div>
                    </div>
                    {/* Products */}
                    <div className="pb-8">
                      <ShopProductGridListView products={products} styles={styles} />
                    </div>

                    {/* Pagination */}
                    {totalProduct > parPage && (
                      <Pagination
                        pageNumber={pageNumber}
                        setPageNumber={setPageNumber}
                        totalItems={totalProduct}
                        parPage={parPage}
                        showItem={Math.floor(totalProduct / parPage)}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default CategoryShop;



//my original code
// import React, { useState, useEffect, lazy } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useSearchParams } from 'react-router-dom';
// import { Range } from 'react-range';

// import { IoIosArrowForward } from "react-icons/io";
// import {AiFillStar} from 'react-icons/ai'
// import {CiStar} from 'react-icons/ci' 
// import {BsFillGridFill} from 'react-icons/bs'
// import {FaThList} from 'react-icons/fa'

// import { price_range_product, query_products } from '../store/reducers/homeReducer';

// import Header from '../components/Header';
// import Footer from '../components/Footer';
// import Pagination from '../components/Pagination';
// import ShopBanner from '../components/ShopBanner';
// import Products from '../components/products/Products';
// import ShopProductGridListView from '../components/products/ShopProductGridListView';

// import config from '../config';

// const CategoryShop = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL
//     const intPriceRangeStep = config.INT_FRONTEND_PRICE_RANGE_STEP

//     const { products, priceRange, latest_product, totalProduct, parPage } = useSelector(state => state.home)
//     const { seller } = useSelector(state => state.seller)

//     const sellerId = seller?._id 
//     const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1
//     const sellerProductTerm = seller?.productTerm
//     const sellerProductPluralTerm = seller?.productPluralTerm
    
//     const sellerBoolShowSitePayments = seller?.isVisibleSitePayments === 'Show' ? true : false
//     const sellerBoolShowSiteRating = seller?.isVisibleSiteRating === 'Show' ? true : false
//     const sellerBoolShowSiteProductsUnderFilter = seller?.isVisibleSiteProductsUnderFilter === 'Show' ? true : false

//     let sellerBoolShowSidebar = true
//     if(sellerBoolShowSitePayments || sellerBoolShowSiteRating || sellerBoolShowSiteProductsUnderFilter) 
//         { sellerBoolShowSidebar = false }
//     else 
//         { sellerBoolShowSidebar = true }
    
//     let [searchParams, setSearchParams] = useSearchParams()
//     const category = searchParams.get('category')
//     const mainIngredient = ''
//     const [FMP, setFmp] = useState('')
//     const [cookingMethod, setCookingMethod] = useState('')
//     const [byThePan, setByThePan] = useState('')
//     const [dietaryRestrictions, setDietaryRestrictions] = useState('')
//     const [cuisineType, setCuisineType] = useState('')
//     const [holiday, setHoliday] = useState('')

//     //console.log(category)

//     const dispatch = useDispatch()
    
//     useEffect(() => { 
//         dispatch(price_range_product(sellerFrontendURL))
//     },[])
    
//     useEffect(() => { 
//         setState({
//             values: [priceRange.low, priceRange.high]
//         })
//     },[priceRange])

//     const [filter, setFilter] = useState(true) 

//     const [state, setState] = useState({values: [priceRange.low, priceRange.high]})
//     //console.log(priceRange.low)
//     //console.log(priceRange.high)

//     //const priceRangeMinPrice = state.priceRange.low || 0; 
//     //const priceRangeMaxPrice = state.priceRange.high || 100;

//     const [rating, setRating] = useState('')
//     const [styles, setStyles] = useState('grid')

//     const [pageNumber, setPageNumber] = useState(1)
//     const [sortPrice, setSortPrice] = useState('') 

//     useEffect(() => { 
//         dispatch(
//             query_products({
//                 webSiteOrigin: sellerFrontendURL,
//                 low: state.values[0] || '',
//                 high: state.values[1] || '',
//                 category,
//                 mainIngredient,
//                 FMP,
//                 cookingMethod,
//                 byThePan:'',
//                 dietaryRestrictions:'',
//                 cuisineType: '',
//                 holiday: '',
//                 rating,
//                 sortPrice,
//                 pageNumber
//             })
//          )
//     },[sellerFrontendURL, state.values[0], state.values[1], category, mainIngredient, FMP, cookingMethod, byThePan, dietaryRestrictions, cuisineType, holiday, rating, sortPrice, pageNumber])
    
//     const resetFilter = () => {
//         setRating('')
//         dispatch(
//             query_products({
//                 webSiteOrigin: sellerFrontendURL,
//                 low: state.values[0],
//                 high: state.values[1],
//                 category,
//                 mainIngredient: '',
//                 rating: '',
//                 sortPrice,
//                 pageNumber
//             })
//          )
//          dispatch(price_range_product(sellerFrontendURL))
//     }
    
//     return (
//         <div>
//             <Header/>
//             <section className='py-2'>
//                 <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto'>
//                     <div className='mb-2'>
//                         <ShopBanner homePage={'Home'} homeLink={'/'} currentPageTop={'Category Page'} currentPageTopLink={''} 
//                             currentPageBottom1={category} currentPageBottomLink1={'/productsCategory?category=' + category} 
//                             currentPageBottom2={''} currentPageBottomLink2={''} />
//                     </div>
//                     <div className={` md:block hidden ${!filter ? 'mb-6' : 'mb-0'} `}>
//                         <button onClick={() => setFilter(!filter)} 
//                             className='text-center rounded-lg w-full py-2 px-3 text-white' 
//                             style={{backgroundColor:sellerPrimaryColor1}}>
//                             Filter {sellerProductPluralTerm}
//                         </button> 
//                     </div>
//                     <div className='w-full flex flex-wrap'>
//                         <div className={`w-3/12 md-lg:w-4/12 md:w-full pr-8 
//                             ${filter ? 'md:h-0 md:overflow-hidden md:mb-6' : 'md:h-auto md:overflow-auto md:mb-0' } `}>
//                             <div className={` ${sellerBoolShowSitePayments ? 'py-2 flex flex-col gap-5' : 'hidden'} `}>
//                                 <h2 className='text-2xl font-bold mb-3' style={{color:sellerPrimaryColor1}}>Price</h2>
//                                 <Range
//                                     step={intPriceRangeStep} 
//                                     min={priceRange.low} //  priceRangeMinPrice
//                                     max={priceRange.high} //  priceRangeMaxPrice
//                                     values={(state.values)} onChange={(values) => setState({values})}
//                                     renderTrack={({props,children}) => (
//                                         <div {...props} className='w-full h-[6px] bg-slate-200 rounded-full cursor-pointer'>
//                                             {children}
//                                         </div>
//                                     )}
//                                     renderThumb={({ props }) => (
//                                         <div className='w-[15px] h-[15px] bg-[#059473] rounded-full' {...props} />
//                                     )} 
//                                 />  
//                                 <div>
//                                     <span className='font-bold text-lg' style={{color:sellerPrimaryColor1}}>${Math.floor(state.values[0])} - ${Math.floor(state.values[1])}</span>  
//                                 </div>
//                             </div>
//                             <div className={` ${sellerBoolShowSiteRating ? 'py-3 flex flex-col gap-4' : 'hidden'} `}>
//                                 <h2 className='text-2xl font-bold mb-3' style={{color:sellerPrimaryColor1}}>Rating</h2>
//                                 <div className='flex flex-col gap-3'>
//                                     <div onClick={() => setRating(5)} className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                     </div>
//                                     <div onClick={() => setRating(4)} className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><CiStar/> </span>
//                                     </div>
//                                     <div onClick={() => setRating(3)} className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                     </div>
//                                     <div onClick={() => setRating(2)} className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                     </div>
//                                     <div onClick={() => setRating(1)} className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
//                                         <span><AiFillStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                     </div>
//                                     <div className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                     </div> 
//                                 </div> 
//                             </div>
//                             <button onClick={resetFilter} style={{backgroundColor:sellerPrimaryColor1}} 
//                                 className={` ${(!sellerBoolShowSitePayments && !sellerBoolShowSiteRating) ? 'hidden' : ''} 
//                                     text-center rounded-lg w-full py-2 px-3 text-white`}>
//                                 Reset Filter
//                             </button>
//                             <div className={` ${sellerBoolShowSiteProductsUnderFilter ? '' : 'hidden'} py-5 flex flex-col gap-4 md:hidden`}>
//                                 <Products title={'Latest '+ sellerProductPluralTerm} products={latest_product} parentPage={'CategoryShop'} />
//                             </div> 
//                         </div>
//                         <div className={` ${sellerBoolShowSidebar ? '' : 'w-9/12 md-lg:w-8/12'} md:w-full`}>
//                             <div className={` ${sellerBoolShowSidebar ? '' : 'pl-8'} md:pl-0`}>
//                                 <div className='py-2 bg-white mb-10 px-3 rounded-md flex justify-between items-start border'>
//                                     <h2 className='text-lg font-medium' style={{color:sellerPrimaryColor1}}> 
//                                         {totalProduct} {sellerProductTerm}
//                                         <span className= {` ${totalProduct > 1 ? '': 'hidden'} `} >s </span>
//                                         ({category})
//                                     </h2>
//                                     <div className='flex justify-center items-center gap-3'>
//                                         <select onChange={(e)=>setSortPrice(e.target.value)}  name="" id=""
//                                             className='p-1 border outline-0 font-semibold' style={{color:sellerPrimaryColor1}}>
//                                             <option value="">Sort By</option>
//                                             <option className={` ${sellerBoolShowSitePayments ? '' : 'hidden'} `} value="low-to-high">Low to High Price</option>
//                                             <option className={` ${sellerBoolShowSitePayments ? '' : 'hidden'} `}  value="high-to-low">High to Low Price </option>
//                                         </select>
//                                         <div className='flex justify-center items-start gap-4 md-lg:hidden'>
//                                             <div onClick={()=> setStyles('grid')} 
//                                                 className={`p-2 ${styles === 'grid' && 'bg-slate-300'} text-slate-600 hover:bg-slate-300 cursor-pointer rounded-sm `} >
//                                                 <BsFillGridFill style={{color:sellerPrimaryColor1}} />  
//                                             </div>
//                                             <div onClick={()=> setStyles('list')} 
//                                                 className={`p-2 ${styles === 'list' && 'bg-slate-300'} text-slate-600 hover:bg-slate-300 cursor-pointer rounded-sm `} >
//                                                 <FaThList style={{color:sellerPrimaryColor1}} />  
//                                             </div> 
//                                         </div> 
//                                     </div> 
//                                 </div> 
//                                 <div className='pb-8'>
//                                     <ShopProductGridListView products={products} styles={styles} />  
//                                 </div>
//                                 <div>
//                                     {totalProduct > parPage &&  
//                                         <Pagination 
//                                             pageNumber={pageNumber} 
//                                             setPageNumber={setPageNumber} 
//                                             totalItems={totalProduct} 
//                                             parPage={parPage} 
//                                             showItem={Math.floor(totalProduct / parPage )} />
//                                     }
//                                 </div>
//                             </div> 
//                         </div>
//                     </div>
//                 </div> 
//             </section>
//             <Footer/>
//         </div>
//     );
// };

// export default CategoryShop;




